export const FORCE_RESET_PASSWORD_EXCEPTION = "ForceResetPasswordException";
export const FORCE_RESET_PASSWORD_EXCEPTION_STATUS = 403;

export const INVALID_SESSION_EXCEPTION = "INVALID_SESSION_EXCEPTION";
export const INVALID_SESSION_EXCEPTION_STATUS = 401;

export const INSUFFICIENT_ACCESS_EXCEPTION = "INSUFFICIENT_ACCESS";
export const INSUFFICIENT_ACCESS_EXCEPTION_STATUS = 403;

export const USER_LOCALSTORAGE_KEY = "__user";
